<div class="preset-grid">
  <div class="preset" [class.active]="presetIsActive([12])" (click)="selectPreset([12])">
    <span class="col col-12"></span>
  </div>
  <div class="preset" [class.active]="presetIsActive([6, 6])" (click)="selectPreset([6, 6])">
    <div class="col col-6"></div>
    <div class="col col-6"></div>
  </div>
  <div class="preset" [class.active]="presetIsActive([4, 8])" (click)="selectPreset([4, 8])">
    <div class="col col-4"></div>
    <div class="col col-8"></div>
  </div>
  <div class="preset" [class.active]="presetIsActive([8, 4])" (click)="selectPreset([8, 4])">
    <div class="col col-8"></div>
    <div class="col col-4"></div>
  </div>
  <div class="preset" [class.active]="presetIsActive([4, 4, 4])" (click)="selectPreset([4, 4, 4])">
    <div class="col col-4"></div>
    <div class="col col-4"></div>
    <div class="col col-4"></div>
  </div>
  <div
    class="preset"
    [class.active]="presetIsActive([3, 3, 3, 3])"
    (click)="selectPreset([3, 3, 3, 3])"
  >
    <div class="col col-3"></div>
    <div class="col col-3"></div>
    <div class="col col-3"></div>
    <div class="col col-3"></div>
  </div>
  <div
    class="preset"
    [class.active]="presetIsActive([2, 2, 2, 2, 2, 2])"
    (click)="selectPreset([2, 2, 2, 2, 2, 2])"
  >
    <div class="col col-2"></div>
    <div class="col col-2"></div>
    <div class="col col-2"></div>
    <div class="col col-2"></div>
    <div class="col col-2"></div>
    <div class="col col-2"></div>
  </div>
  <button class="no-style preset custom-preset" (click)="toggleCustomPanel()">
    <span class="col col-12" trans>Custom</span>
  </button>
</div>

<form
  class="custom-span-panel input-container"
  (ngSubmit)="applyCustomPreset()"
  ngNativeValidate
  *ngIf="customPanelOpen"
>
  <input
    #customInput
    type="text"
    [formControl]="customPresetControl"
    (blur)="applyCustomPreset()"
    placeholder="4 + 4 + 4"
    required
    minlength="3"
    pattern="[1-9\+ ]+"
  />
  <div class="error" *ngIf="customPresetControl.errors?.customPreset" trans>
    This preset is not valid. Added values should equal 12.
  </div>
</form>
